<script>
  import { onMount } from "svelte";
  import { Chart } from "chart.js";

  let { data, chartDateLabels, isInModal = false } = $props();

  let followingsChart = $state(null);
  let canvasId = `followingsChart_${Math.random().toString(36).substr(2, 9)}`;

  function setupFollowingsChart() {
    let snapspotData = $state.snapshot(data?.following_growth);

    const followingsCtx = document.getElementById(canvasId).getContext("2d");

    followingsChart = new Chart(followingsCtx, {
      type: "line",
      data: {
        labels: chartDateLabels(snapspotData?.dates || []),
        datasets: [
          {
            label: "Following",
            data: snapspotData?.following || [],
            fill: true,
            backgroundColor: "rgba(147, 51, 234, 0.2)",
            borderColor: "rgba(147, 51, 234, 1)",
            tension: 0.4,
            pointBackgroundColor: "rgba(147, 51, 234, 1)",
            pointBorderColor: "#fff",
            pointBorderWidth: 2,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false,
          },
        },
        scales: {
          y: {
            beginAtZero: false,
            ticks: {
              callback: function (value) {
                return Math.round(value).toLocaleString();
              },
            },
            grid: {
              color: "rgba(0, 0, 0, 0.1)",
            },
          },
          x: {
            grid: {
              color: "rgba(0, 0, 0, 0.1)",
            },
          },
        },
      },
    });
  }

  function updateFollowingsChart() {
    if (!followingsChart) return;

    let snapspotData = $state.snapshot(data?.following_growth || {});
    followingsChart.data.labels = chartDateLabels(snapspotData?.dates || []);
    followingsChart.data.datasets[0].data = snapspotData?.following || [];

    followingsChart.update();
  }

  $effect(() => {
    updateFollowingsChart();
  });

  // Resize chart when modal visibility changes
  $effect(() => {
    if (isInModal && followingsChart) {
      setTimeout(() => {
        followingsChart.resize();
      }, 100);
    }
  });

  onMount(() => {
    setupFollowingsChart();

    return () => {
      if (followingsChart) followingsChart.destroy();
    };
  });
</script>

<div class="bg-white shadow rounded-lg p-6">
  <h3 class="text-lg font-medium text-gray-900 mb-4">
    Following Growth {@html data?.following_growth?.dates?.length < 3
      ? "<span class='text-gray-500 text-xs pl-1'>(more data will be collected over time)</span>"
      : ""}
  </h3>
  <div class={isInModal ? "h-96" : "h-64"}>
    <canvas id={canvasId}></canvas>
  </div>
</div>
